var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"m-nav-item",class:{
    active: _vm.active,
    disabled: _vm.disabled
  },style:({padding: _vm.padding}),attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.name || _vm.path && !_vm.disabled)?_c('router-link',{attrs:{"to":{name: _vm.name, path: _vm.path}}},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82e047f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m/navbar/nav-item.vue
// module id = 5dAM
// module chunks = 90